import {getCioRecommendations} from '@/helpers/constructorHelpers'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '~/app/hooks/use-app-origin'

export const useCioRecommendations = (
    podId: string,
    productIds: string[],
    groupId: string,
    shouldQuery: boolean
) => {
    const appOrigin = useAppOrigin()
    return useQuery({
        queryKey: ['constructor-product-recommendations', podId, productIds, groupId],
        queryFn: () => {
            return getCioRecommendations(appOrigin, {podId, productIds, groupId})
        },
        enabled: shouldQuery,
        retry: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: 'always',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        staleTime: 0,
        cacheTime: 0,
        keepPreviousData: false,
        onError: (error) => {
            console.error('CioRecommendations error:', error)
        }
    })
}
